import { gql } from "@apollo/client";

export const ADD_TREATMENT = gql`
  mutation CreateProgramHistory(
    $program_type: ProgramType!
    $start_date: String!
    $end_date: String
    $account_id: Int!
    $specialist_id: Int!
  ) {
    createProgramHistory(
      data: {
        program_type: $program_type
        start_date: $start_date
        end_date: $end_date
        account_id: $account_id
        specialist_id: $specialist_id
      }
    ) {
      id
      program_type
      start_date
      end_date
      account_id
      specialistId
    }
  }
`;

export const GET_PROGRAMS = gql`
  query {
    programEnums
  }
`;
